"use client";
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import * as React from 'react';
import { Icon } from '../../Icon/Icon.web.js';

var _excluded = ["color", "size"];
var IconPrices = function IconPrices(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === undefined ? 'currentColor' : _ref$color,
    _ref$size = _ref.size,
    sizeProp = _ref$size === undefined ? '48px' : _ref$size,
    props = _objectWithoutProperties(_ref, _excluded);
  var size = sizeProp;
  return /*#__PURE__*/React.createElement(Icon, props, /*#__PURE__*/React.createElement("svg", {
    fill: "none",
    viewBox: "0 0 48 48",
    width: size,
    height: size
  }, /*#__PURE__*/React.createElement("path", {
    fill: color,
    fillRule: "evenodd",
    d: "m23 11.514 9.914-7.78 10.089 7.777-.123 20.719c0 2.503-1.413 4.64-3.672 4.764L39 37h-4v-2h4c1.034 0 1.813-1.075 1.876-2.578l.004-.198.117-19.735-8.072-6.223L25 12.485V15h-2zm7.76 2.136a2.16 2.16 0 1 1 4.32 0 2.16 2.16 0 0 1-4.32 0m3.32 0a1.16 1.16 0 1 0-2.32 0 1.16 1.16 0 0 0 2.32 0m-1.314 13.932L18.238 13.054 6.13 14.934l-1.978 12.21 3.357 3.367c.14 4.552 2.15 8.359 4.592 8.359l.172-.006c.788-.053 1.365-.483 2.005-1.385l.073-.107 4.322 4.334a4.39 4.39 0 0 0 6.216 0l7.88-7.91a4.39 4.39 0 0 0-.002-6.214m-19.134 9.07-5.05-5.064c.374 3.553 1.95 6.282 3.518 6.282.493 0 .857-.251 1.372-.984zm-5.08-7.927 11.536 11.569c.404.404.937.65 1.502.694l.19.008a2.4 2.4 0 0 0 1.692-.702l7.882-7.912a2.39 2.39 0 0 0-.001-3.385L17.54 15.186l-9.67 1.501-1.582 9.768 1.356 1.36c.373-2.793 1.434-5.146 2.779-6.21a2.16 2.16 0 1 1 .34 1.053c-1.084 1.086-1.988 3.383-2.211 6.067m3.036-6.635a1.16 1.16 0 0 0 1.885.142c-.38-.24-.85-.331-1.373-.242q-.257 0-.512.1m2.122-.869a1.16 1.16 0 0 0-2.205-.164q.249-.06.505-.059a2.8 2.8 0 0 1 1.7.223",
    clipRule: "evenodd"
  })));
};

export { IconPrices, IconPrices as default };
